<template>
    <Sidebar />
    <Topbar />
    <main class="nxl-container">
        <div class="nxl-content">
            <div class="main-content">
                <slot></slot>
            </div>
        </div>
        <Footer />
    </main>
</template>

<script>
// import Breadcrumbs from '@/components/site/Breadcrumbs.vue'
import Sidebar from '@/components/site/Sidebar.vue'
import Topbar from '@/components/site/Topbar.vue'
import Footer from '@/components/site/Footer.vue'

export default {
    name: 'Container',
    components: {
        Sidebar,
        Topbar,
        Footer,
        // Breadcrumbs
    }
}
</script>